/** A gap of at least 30 minutes starts a new analytics session. */
export const SESSION_TIMEOUT_MS = 30 * 60 * 1_000

// These parameter names must stay in sync with the API's own URL-tagging constants.

/** Tagged business query parameter. */
export const QT_BUSINESS_ID_PARAM = "qt_business_id"

/** Source-content type query parameter. */
export const QT_SRC_CONTENT_TYPE_PARAM = "qt_src_content_type"

/** Source-content ID query parameter. */
export const QT_SRC_CONTENT_ID_PARAM = "qt_src_content_id"

/** Campaign ID query parameter. */
export const QT_CAMPAIGN_ID_PARAM = "qt_campaign_id"

/** Person ID query parameter. */
export const QT_PERSON_ID_PARAM = "qt_person_id"

/** Email ID query parameter. */
export const QT_EMAIL_ID_PARAM = "qt_email_id"

/** UTM source query parameter. */
export const UTM_SOURCE_PARAM = "utm_source"

/** UTM medium query parameter. */
export const UTM_MEDIUM_PARAM = "utm_medium"

/** UTM campaign query parameter. */
export const UTM_CAMPAIGN_PARAM = "utm_campaign"

/** UTM content query parameter. */
export const UTM_CONTENT_PARAM = "utm_content"

/** Social sources accepted on tagged URLs. */
export const SOCIAL_SOURCES: readonly [
  "linkedin",
  "twitter",
  "instagram",
  "facebook",
  "tiktok",
] = ["linkedin", "twitter", "instagram", "facebook", "tiktok"]
